import React, { useEffect, useMemo } from 'react'
import MobileCategories from '../MobileCategories/MobileCategories'
import MobileCategoriesOptions from '../MobileCategories/MobileCategoriesOptions'
import useDelayUnmount from 'hooks/useDelayUnmount'
import AccountLinksDropDown from '../../IconActions/User/AccountLinksDropDown'
import SessionConnector, { ConnectorProps as SessionProps } from 'containers/Session'
import AuthLinksDropDown from '../../IconActions/User/AuthLinksDropDown'
import { useHeaderContext } from '../../HeaderContext'

const MENU_CONTENT = {
  ['null']: null,
  ['categories']: MobileCategories,
  ['subCategories']: MobileCategoriesOptions,
  ['user']: AccountLinksDropDown,
  ['auth']: AuthLinksDropDown,
  ['search']: null,
}

const MenuContent = ({ isSessionReady }: SessionProps) => {
  const { mobileHeaderConfig, setMobileHeaderConfig } = useHeaderContext()
  // this is to delay the unmount of the component to be able to see the animation, if you need animation increase the value to 500
  const shouldRenderChild = useDelayUnmount(mobileHeaderConfig.isMobileMenuOpen, 0)

  const ContentComponent = useMemo(
    () => (shouldRenderChild ? MENU_CONTENT[mobileHeaderConfig.mobileMenuContent] : null),
    [shouldRenderChild, mobileHeaderConfig.mobileMenuContent]
  )

  useEffect(() => {
    const handleScroll = () => {
      setMobileHeaderConfig((previousMobileHeaderConfig) => ({
        ...previousMobileHeaderConfig,
        mobileTopHeader: 'search',
        isMobileMenuOpen: false,
      }))
    }

    if (mobileHeaderConfig.isMobileMenuOpen) {
      window.addEventListener('scroll', handleScroll, { passive: true })
    }

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [mobileHeaderConfig.isMobileMenuOpen])

  if (!isSessionReady) {
    return null
  }

  return shouldRenderChild && ContentComponent ? <ContentComponent /> : null
}

export default SessionConnector(MenuContent)
